import "@shoelace-style/shoelace/dist/components/input/input.js";

import { html, TemplateResult } from "lit";
import { BaseElement } from "../BaseElement";
import { makeCustomEvent } from "../../Utils";
import { wrapWithTooltipAndHelp } from "./WrapWithTooltipAndHelp";

export function renderInput(
    root: BaseElement,
    object: any,
    prop: string,
    label: string | undefined,
    type: "number" | "text" = "text",
    readonly = false,
    placeholder: string | undefined = undefined,
    helpMsg: string | undefined = undefined
): TemplateResult {
    if (!object) {
        return html``;
    }
    let elem = html` <sl-input
        pill
        filled
        size="medium"
        class="editor-grid-item"
        ?readonly=${readonly}
        .placeholder=${placeholder ?? ""}
        type=${type}
        value=${object[prop] ?? ""}
        @sl-input=${(e: any) => {
            object[prop] = type === "number" ? Number.parseFloat(e.target.value) : e.target.value;
            root.dispatchEvent(makeCustomEvent("ds-item-changed"));
        }}
        style="flex-grow:1"
    ></sl-input>`;

    if (helpMsg) {
        elem = wrapWithTooltipAndHelp(root, elem, helpMsg);
    }

    return html`${label
        ? html`<span class="editor-label editor-grid-item">${label}</span>`
        : html``}
    ${elem}`;
}
